"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Checkbox = _interopRequireDefault(require("@mui/material/Checkbox"));
var _styles = _interopRequireDefault(require("./styles.scss"));
var Checkbox = function Checkbox(props) {
  var className = props.className,
    children = props.children,
    indicator = props.indicator,
    subtext = props.subtext,
    sx = props.sx,
    themeColor = props.themeColor,
    id = props.id;
  var sxProp = sx || {
    color: themeColor
  };
  var renderIndicator = function renderIndicator() {
    if (!indicator) {
      return null;
    }
    if (typeof indicator === 'string') {
      return /*#__PURE__*/_react.default.createElement("span", {
        className: "indicator",
        style: {
          backgroundColor: indicator
        }
      });
    }
    return /*#__PURE__*/_react.default.createElement("span", {
      className: "indicator icon"
    }, indicator);
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(_styles.default.cbox, " ").concat(className)
  }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, (0, _extends2.default)({
    color: themeColor,
    sx: sxProp
  }, props)), renderIndicator(), /*#__PURE__*/_react.default.createElement("label", {
    className: "cbox-label",
    htmlFor: id
  }, children, subtext ? /*#__PURE__*/_react.default.createElement("span", {
    className: "cbox-subtext"
  }, subtext) : null));
};
Checkbox.propTypes = {
  className: _propTypes.default.string,
  /** Element display within Checkbox wrapper.
   * `string` will produce a label, other elements will render as-is
   * */
  children: _propTypes.default.oneOf(_propTypes.default.string, _propTypes.default.shape({})).isRequired,
  /** Unique identifier for checkbox
   * Providing this value allows checkbox label to be clickable in the DOM.
   */
  id: _propTypes.default.oneOf(_propTypes.default.string, _propTypes.default.number),
  /** Icon to the right of the checkbox.
   * `string` will produce a colored circle, other elements will render as-is
   * */
  indicator: _propTypes.default.oneOf(_propTypes.default.string, _propTypes.default.shape({})),
  /** Text that will display beneath the label text */
  subtext: _propTypes.default.string,
  /** sx documentation: https://mui.com/system/getting-started/the-sx-prop/ */
  sx: _propTypes.default.shape({}),
  /** Modifies MUI Checkbox's `color` value.
   * Value must match item from palette section of theme
   * */
  themeColor: _propTypes.default.string
};
Checkbox.defaultProps = {
  className: '',
  id: null,
  indicator: null,
  subtext: null,
  sx: null,
  themeColor: 'text'
};
var _default = Checkbox;
exports.default = _default;